<template>
  <div>
    <span class="caption grey--text text--darken-1">{{$t('common.Age')}}</span>
    <v-text-field
      v-model="ageStr"
      @click:clear="setAgeEmpty"
      clearable
      :readonly="!edit"
      @keypress="isNumber($event)"
      solo
      class="thin-border"
    >
    </v-text-field>

    <v-card class="box-container" v-if="underTwoYears">
      <v-text-field
        class="box-content"
        :value="years"
        readonly
        label="Anos"
        type="number"
      >
      </v-text-field>

      <v-text-field
        class="box-content"
        v-model="ageMonths"
        label="Meses"
        min="0"
        max="11"
        type="number"
      />
      <v-text-field
        class="box-content"
        v-model="ageDays"
        label="Dias"
        min="0"
        max="31"
        type="number"
      />
      <v-card-actions>
        <v-btn small color="grey" icon ripple @click="close()">
          <v-icon color="white">check</v-icon></v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    age: { default: '' }
  },
  data() {
    return {
      edit: true,
      ageStr: '',
      years: '',
      months: 0,
      days: 0
    }
  },
  computed: {
    underTwoYears() {
      return this.years < 2 && this.years && this.ageStr != ''
    },
    ageMonths: {
      get() {
        return this.months
      },
      set(val) {
        val > 11 ? (this.months = 11) : (this.months = val)
      }
    },
    ageDays: {
      get() {
        return this.days
      },
      set(val) {
        val > 31 ? (this.days = 31) : (this.days = val)
      }
    }
  },
  created() {
    this.ageStr = this.age
    if (parseInt(this.age) < 2 || this.age == '> 90') {
      this.edit = false
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    close() {
      this.ageStr = `${this.years}a${this.months}m${this.days}d`
      this.$emit('update:age', this.ageStr)
      this.years = ''
      this.months = 0
      this.days = 0
      this.edit = false
    },

    setAgeEmpty() {
      this.$emit('update:age', '')
      this.ageStr = ''
      this.edit = true
    }
  },
  watch: {
    ageStr() {
      this.years = this.ageStr
      if (parseInt(this.ageStr) > 90) {
        this.ageStr = '> 90'
        this.$emit('update:age', this.ageStr)
      } else {
        this.$emit('update:age', this.ageStr)
        this.months = 0
        this.days = 0
      }
    }
  }
}
</script>

<style>
.box-container {
  display: flex;
  width: auto;
  height: auto;
}
.box-content {
  padding: 10px;
  width: 25%;
  height: auto;
}
</style>
